import React from 'react';
import { connect } from 'react-redux';
import {
  getFilteredResults
} from '../actions';
import types from '../constants/actionTypes';

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MdSort from 'react-icons/lib/md/sort';
import MdExpandLess from 'react-icons/lib/md/expand-less';
import MdExpandMore from 'react-icons/lib/md/expand-more';
import Divider from 'material-ui/Divider';

class SortOrder extends React.Component {

  handleSortChange = (orderBy, order, e) => {

    this.props.dispatch({
      type: types.activeFilters.SET_SORT_ORDER,
      orderBy: orderBy,
      order: order,
    });

    this.props.dispatch(getFilteredResults());
  };

  render() {
    return (
      <div style={this.props.style}>
        <IconMenu
          iconButtonElement={
            <IconButton
              touch={true}
              disableTouchRipple={true}
              tooltip="Sort"
            >
              <MdSort fill="black" width="24" height="24" />
            </IconButton>
          }
        >
          <MenuItem primaryText="Sorty By" disabled={true} />
          <Divider />
          <MenuItem
            primaryText="Viewers"
            onTouchTap={this.handleSortChange.bind(this, 'default', 'ASC')}
          />
          <MenuItem
            primaryText="First Name"
            onTouchTap={this.handleSortChange.bind(this, 'first_name', 'ASC')}
          />
          <MenuItem
            primaryText="Last Name"
            onTouchTap={this.handleSortChange.bind(this, 'last_name', 'ASC')}
          />
          <MenuItem
            primaryText="Date"
            onTouchTap={this.handleSortChange.bind(this, 'updated_at', 'ASC')}
            rightIcon={<MdExpandLess fill="black" />}
          />
          <MenuItem
            primaryText="Date"
            onTouchTap={this.handleSortChange.bind(this, 'updated_at', 'DESC')}
            rightIcon={<MdExpandMore fill="black" />}
          />
        </IconMenu>
      </div>
    );
  }
}

// SortOrder.propTypes = {
//   view: React.PropTypes.string.isRequired,
// };

function mapStateToProps(state) {
  return {
    activeFilters: state.get('activeFilters'),
  };
};

export default connect(mapStateToProps)(SortOrder);



/** WEBPACK FOOTER **
 ** ./components/SortOrder.js
 **/